import {Component, OnDestroy, OnInit} from '@angular/core';
import {CupPageBase} from '../../general/CupPageBase';
import {ProductBase} from '../../../../shared-gen/Model/Products/ProductBase';
import {Menu} from '../../../../shared-gen/Model/Menus/Menu';
import {AppService} from '../../../services/app.service';

@Component({
	selector: 'app-tur-cup',
	templateUrl: './tur-cup.component.html',
	styleUrls: ['./tur-cup.component.scss']
})
export class TurCupComponent extends CupPageBase implements OnInit, OnDestroy {
	menu: Menu;
	productBases: ProductBase[] = [];

	constructor(app: AppService) {
		super(app);
	}
}
